import { UpdatePasswordForm } from '@r/components/user/forms/update-password-form.tsx';
import { Card, CardContent } from '@r/components/ui/card.tsx';
import { ComputerIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';

export const MyAccount = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className="mb-10">
        <div className="flex flex-nowrap items-center mb-3">
          <h1 className="flex items-center text-4xl font-bold">
            {t('menu.account.personal.informations')}
          </h1>
        </div>

        <p className="font-light text-muted-foreground">{t('personal.information.description')}</p>
      </div>

      <Card className="p-10">
        <CardContent className="space-y-2.5">
          <div className="flex items-center text-foreground">
            <ComputerIcon className="mr-3" />

            <h3 className="flex items-center font-bold text-base sm:text-xl md:text-3xl">
              {t('personal.security.title')}
            </h3>
          </div>

          <div className="flex flex-col gap-5 mt-2 sm:flex-row">
            <div className="flex flex-col gap-5 w-full max-w-sm">
              <UpdatePasswordForm variant="admin" />
            </div>
          </div>
        </CardContent>
      </Card>
    </Fragment>
  );
};
